import request from '@/utils/request'
import API from '@/api/index.js'

/**
 * 问卷列表
 * @param pageSize
 * @param current
 * @returns {*}
 */
export function dwSurveyList (params) {
  // const params = {pageSize, current, surveyName, surveyState, visibility, startTime, endTime, answerNum, groupId1, groupId2}
  return request({
    url: API.surveyList,
    method: 'get',
    params
  })
}
/**
 * 创建问卷
 * @param data
 * @returns {*}
 */
export function dwSurveyCreate (data) {
  return request({
    url: API.surveyCreate,
    method: 'post',
    data
  })
}

/**
 * 更新问卷状态
 * @param surveyId
 * @param surveyState
 * @returns {*}
 */
export function dwSurveyUpState (surveyId, surveyState) {
  const params = {
    surveyId,
    surveyState
  }
  return request({
    url: API.surveyUpState,
    method: 'post',
    params
  })
}
/**
 * 复制问卷
 * @param data
 * @returns {*}
 */
export function dwSurveyCopy (params) {
  /* const params = {
    fromSurveyId,
    surveyName,
    tag: '2',
    groupId1,
    groupId2
  } */
  return request({
    url: API.surveyCopy,
    method: 'post',
    params
  })
}
/**
 * 获取问卷信息
 * @param surveyId
 * @returns {*}
 */
export function dwSurveyInfo (surveyId) {
  const params = {
    id: surveyId
  }
  return request({
    url: API.surveyInfo,
    method: 'get',
    params
  })
}
/**
 * 更新问卷信息
 * @param data
 * @returns {*}
 */
export function dwSurveyUpdate (data) {
  return request({
    url: API.surveyUpdate,
    method: 'put',
    data
  })
}
/**
 * 更新问卷信息
 * @param data
 * @returns {*}
 */
export function dwSurveyDelete (data) {
  return request({
    url: API.surveyDelete,
    method: 'delete',
    data
  })
}

/**
 * 恢复删除的问题
 * @param params
 * @returns {Promise<*>}
 */
export function dwSurveyRecover (data) {
  return request({
    url: '/api/dwsurvey/app/survey/recover.do',
    method: 'delete',
    data
  })
}

/**
 * 获取问卷的统计信息
 * @param surveyId
 * @returns {*}
 */
export function dwSurveyReport (surveyId) {
  const params = {
    surveyId
  }
  return request({
    url: API.surveyReport,
    method: 'get',
    params
  })
}
/**
 * 获取问卷的答卷列表
 * @param pageSize
 * @param current
 * @param surveyId
 * @returns {*}
 */
export function dwSurveyAnswerList (pageSize, current, surveyId, isEffective, city, ipAddr, handleState,saveType, beginDate, endDate) {
  const params = {
    pageSize,
    current,
    surveyId,
    isEffective,
    city,
    ipAddr,
    handleState,
    saveType,
    beginDate,
    endDate
  }
  return dwSurveyAnswerListByParams(params)
}

export function dwSurveyAnswerListByParams (params) {
  return request({
    url: API.surveyAnswerList,
    method: 'get',
    params
  })
}
/**
 * 更新问卷信息
 * @param data
 * @returns {*}
 */
export function dwSurveyAnswerDelete (data) {
  return request({
    url: API.surveyAnswerDelete,
    method: 'delete',
    data
  })
}
/**
 * 获取问卷答卷详情
 * @param answerId
 * @returns {*}
 */
export function dwSurveyAnswerInfo (answerId) {
  const params = {
    answerId
  }
  return request({
    url: API.surveyAnswerInfo,
    method: 'get',
    params
  })
}

export function dwSaveFinishAttr (data) {
  return request({
    url: API.saveFinishAttr,
    method: 'put',
    data
  })
}

export function dwSaveAnLoginStyleAttr (data) {
  return request({
    url: API.saveAnLoginStyleAttr,
    method: 'put',
    data
  })
}

export function queryAnalysis (params) {
  console.debug('queryAnalysisparams')
  console.debug(params)
  return request({
    url: '/api/dwsurvey/app/stats/analysis.do',
    method: 'get',
    params
  })
}

export function queryDsb (params) {
  return request({
    url: '/api/dwsurvey/app/stats/dsb.do',
    method: 'get',
    params
  })
}

export function queryProvinceAnswer (params) {
  return request({
    url: '/api/dwsurvey/app/stats/province-answer-page.do',
    method: 'get',
    params
  })
}

export function queryGroupList (groupType) {
  const params = {groupType}
  return request({
    url: '/api/dwsurvey/survey-group-list.do',
    method: 'get',
    params
  })
}

/**
 * 添加人群包
 * @params 
 * @returns 
 */
export function setCrowdPack (params) {
  return request({
    url: '/api/dwsurvey/admin/survey/setCrowdPack.do',
    method: 'post',
    data: params
  })
}

/**
 * 查询问卷所有的题目和选项
 * @param {surveyId: null, sid: null} data 
 * @returns 
 */
export function surveyAll (data) {
  return request({
    url: API.surveyAll,
    method: 'post',
    params: data,
  })
}

export function getLanguageList() {
  return   [
    {
      label: '中文',
      value: 'zh' // ['zh','ch']
    },
    {
      label: '繁中',
      value: 'tc' // ['hk','tw']
    },
    {
      label: '泰语',
      value: 'th'
    },
    {
      label: '法语',
      value: 'fr'
    },
    {
      label: '英语',
      value: 'en'
    },
    {
      label: '德语',
      value: 'de'
    },
    {
      label: '西班牙语',
      value: 'es'
    },
    {
      label: '俄语',
      value: 'ru'
    }
  ]
}

export function surveyGroupOptions (httpResult) {
  const groupOptions = []
  if (httpResult.resultCode === 200) {
    httpResult.data.forEach((item) => {
      groupOptions.push({label: item.groupName, value: item.id})
    })
  }
  return groupOptions
}

export function dwSurveyAnswerVerified (params) {
  return request({
    url: '/api/dwsurvey/app/answer/answer-verified.do',
    method: 'get',
    params
  })
}

export function dwSurveyAnswerUpdate (params) {
  return request({
    url: '/api/dwsurvey/app/answer/up-answer-effe.do',
    method: 'get',
    params
  })
}

/**
 * 执行异步答卷信息导出
 * @param data
 * @returns {*}
 */
export function dwSurveyAnswerExportSync (params) {
  return request({
    url: API.surveyAnswerExportSync,
    method: 'get',
    params
  })
}

/**
 * 查询异步答卷信息进度信息
 * @param params
 * @returns {*}
 */
export function dwSurveyAnswerExportLogInfo (params) {
  return request({
    url: API.surveyAnswerExportLog,
    method: 'get',
    params
  })
}

export function dwSurveyJsonAnswerSyncDataUpdate (params) {
  return request({
    url: '/api/dwsurvey/app/answer/json-answer-sync.do',
    method: 'get',
    params
  })
}

/**
 * 基于问卷创建模板
 * @param params
 * @returns {*}
 */
export function dwAdminCreateTemplaterBySurvey (data) {
  return request({
    url: '/api/dwsurvey/admin/survey/add2Templater.do',
    method: 'post',
    data
  })
}

export function dwSurveyAnswerLogStatsUpdate (params) {
  return request({
    url: '/api/dwsurvey/app/stats/update-log-data.do',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/dw-survey.js